/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { useLocalization } from '@/data/Localization';
import { normalizeStoreTokenPath } from '@/data/utils/normalizeStoreTokenPath';

type TranslatedRoutes = ReturnType<typeof useLocalization<'Routes'>>;

const VALID_ORIGINS = [
	'https://www.dportenis.mx',
	'https://v9prodauth.dportenis.mx',
	'https://v9qa.dportenis.mx',
	'https://localhost:3343',
];

export const buildCanonicalUrl = ({
	path,
	urlKeywordName,
	staticRoutes,
	origin,
}: {
	path: string[] | string | undefined;
	locale: string;
	urlKeywordName?: string;
	staticRoutes: TranslatedRoutes;
	origin?: string;
}) => {
	const normalizedPath = [normalizeStoreTokenPath({ path, storeUrlKeyword: urlKeywordName })]
		.flat()
		.filter(Boolean)
		.join('/');
	const found = Object.entries(staticRoutes).some(
		([_, value]) =>
			typeof value === 'object' && normalizedPath && value.route.t() === normalizedPath
	);
	if (found) {
		// static route doesn't need
		return '';
	} else {
		const url = `${normalizedPath ? '/' + normalizedPath : '/'}`;
		const isValidOrigin = VALID_ORIGINS.find((validOrigin) => origin?.includes(validOrigin));
		const originUrl = origin && isValidOrigin ? isValidOrigin : '';

		return `${url !== '/' ? `${originUrl}${url}` : originUrl}/`;
	}
};
